import { render, staticRenderFns } from "./dttConfig.vue?vue&type=template&id=5d1448d7&"
import script from "./dttConfig.vue?vue&type=script&lang=ts&"
export * from "./dttConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports